import styles from './SignupLayout.module.css'
import ProgressSteps from '../components/ProgressSteps/ProgressSteps'
import NavigationButton from '../components/NavigationButton/NavigationButton'

const SignupLayout = ({
  step,
  totalSegments = 2,
  heading,
  subHeading,
  children,
  showProgress = true,
  showNavigation = true,
  showBack = true,
  onBack,
  onNext,
  isNextDisabled = false,
  nextText = 'Next',
  nextLoading,
  backLoading,
  nextWidth = '600px',
  nextHeight = '50px',
  backWidth = '121px',
  wrapperMaxWidth,
  nextFooterMaxWidth,
  scrollable = false,
}) => {
  return (
    <div className={styles.page}>
      <div className={styles.wrapper} style={wrapperMaxWidth ? { maxWidth: wrapperMaxWidth } : undefined}>

        {showProgress && (
          <ProgressSteps
            totalSegments={totalSegments}
            step={step}
          />
        )}

        {heading && (
          <h1 className={styles.heading}>{heading}</h1>
        )}

        {subHeading && (
          <p className={styles.subHeading}>{subHeading}</p>
        )}

        {scrollable ? (
          <div className={styles.scrollContainer}>
            {children}
          </div>
        ) : (
          children
        )}

      </div>

      {showNavigation && (
        <NavigationButton
          showBack={showBack}
          onBack={onBack}
          onNext={onNext}
          isNextDisabled={isNextDisabled}
          nextWidth={nextWidth}
          nextHeight={nextHeight}
          backWidth={backWidth}
          nextText={nextText}
          nextLoading={nextLoading}
          backLoading={backLoading}
          footerMaxWidth={nextFooterMaxWidth}
        />
      )}
    </div>
  )
}

export default SignupLayout;
